"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConsentFromOneTrustCookie = getConsentFromOneTrustCookie;
exports.getConsentGroupsFromCookie = getConsentGroupsFromCookie;
exports.isOneTrustConsentActive = isOneTrustConsentActive;
const cookies_1 = require("./cookies");
function getConsentFromOneTrustCookie() {
    var _a;
    const consent = new URLSearchParams((0, cookies_1.getCookie)('OptanonConsent'));
    const groups = (_a = consent
        .get('groups')) === null || _a === void 0 ? void 0 : _a.split(',').map((group) => {
        const [item, enabled] = group.split(':');
        if (enabled === '1')
            return item;
    }).filter(Boolean);
    return groups && `,${groups.join(',')},`;
}
function getConsentGroupsFromCookie() {
    var _a;
    const consent = getConsentFromOneTrustCookie() || '';
    const consentGroups = (_a = consent.split(',').filter((group) => group.startsWith('C'))) !== null && _a !== void 0 ? _a : [];
    return consentGroups;
}
function isOneTrustConsentActive() {
    const consentGroups = getConsentGroupsFromCookie();
    const isCookieAlreadySet = consentGroups.length > 0;
    return isCookieAlreadySet;
}
//# sourceMappingURL=oneTrustCookieHelper.js.map